/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { documentsUpdateFile } from "../../funcs/documentsUpdateFile.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateDocumentFileRequest$inboundSchema,
};

export const tool$documentsUpdateFile: ToolDefinition<typeof args> = {
  name: "documents-update-file",
  description: `Update Document File`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await documentsUpdateFile(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
